import { render, staticRenderFns } from "./ShopProductSeckill.vue?vue&type=template&id=55d33baa&scoped=true"
import script from "./ShopProductSeckill.vue?vue&type=script&lang=js"
export * from "./ShopProductSeckill.vue?vue&type=script&lang=js"
import style0 from "./ShopProductSeckill.vue?vue&type=style&index=0&id=55d33baa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55d33baa",
  null
  
)

export default component.exports